import React, { useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { Label, SpaceDiv, FormItem, BtnContainer } from 'components';
import SelectBox, { Props as SelectBoxProps } from 'components/atoms/SelectBox';
import Input, { Props as InputProps } from 'components/atoms/Input';
import FileImgListUploader, { Props as FileImgListUploaderProps } from 'components/molecules/FileImgListUploader';
import BtnNext, { Props as BtnNextProps } from 'components/molecules/BtnNext';

import {
  LABEL_CARRIERYEAR,
  TITLE_FIELD_PHOTO,
  LABEL_EMAIL,
  CAPTION_EMAIL,
  TITLE_PROFILE_INFO,
} from 'commons/ZimssaString';
import * as PAGE_URL from 'router/PageUrl';

import * as S from './style';
import { ServiceState } from 'stores/ServiceStore';
import { isValidServiceState } from 'commons/ZimssaHelper';

interface Props {
  serviceImages: FileImgListUploaderProps;
  emailProps: {
    isDirectEmailEntry: boolean;
    email1: InputProps;
    email2: SelectBoxProps;
    email3: InputProps;
  };
  carrierYear: SelectBoxProps;
  btnNext: BtnNextProps;
}

function ProfileRegister({ ...props }: Props): React.ReactElement {
  const history = useHistory();
  const { serviceValid, serviceName, serviceImage } = useContext(ServiceState);

  useEffect(() => {
    if (!isValidServiceState(serviceValid, serviceName, serviceImage)) {
      history.push(PAGE_URL.SERVICE_SELECT.path);
    }
  }, [serviceValid, serviceName, serviceImage, history]);

  return (
    <S.ContentsContainer>
      <S.ContentsWrapper>
        <S.WrapperWithPadding>
          <S.TitleLabel contents={TITLE_FIELD_PHOTO} />
        </S.WrapperWithPadding>
        <S.WrapperWithPadding>
          <FileImgListUploader {...props.serviceImages} />
          <S.Divider />
        </S.WrapperWithPadding>
        <S.WrapperWithPadding>
          <S.TitleLabel contents={TITLE_PROFILE_INFO} />
        </S.WrapperWithPadding>
        <S.ItemContainer>
          <FormItem
            itemType={'ROW'}
            label={LABEL_EMAIL}
            caption={
              <Label
                contents={CAPTION_EMAIL}
                color={'blue_900'}
                fontStyle={'caption'}
              />
            }
            optionalChildren={
              props.emailProps.isDirectEmailEntry ? (
                <Input {...props.emailProps.email3} />
              ) : null
            }
          >
            <Input inputType={'EMAIL'} {...props.emailProps.email1} />
            <SelectBox {...props.emailProps.email2} />
          </FormItem>
          <FormItem label={LABEL_CARRIERYEAR}>
            <SelectBox {...props.carrierYear} />
          </FormItem>
        </S.ItemContainer>
      </S.ContentsWrapper>
      <SpaceDiv height={36} />
      <BtnContainer>
        <BtnNext {...props.btnNext} />
      </BtnContainer>
    </S.ContentsContainer>
  );
}

export default ProfileRegister;
